'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var DISABLED_RANGE = exports.DISABLED_RANGE = {
  none: 'NONE',
  beforeToday: 'BEFORETODAY',
  afterToday: 'AFTERTODAY',
  duration: 'DURATION',
  custom: 'CUSTOM'
};

var TRANSFORM_FORMAT = exports.TRANSFORM_FORMAT = {
  'yyyy-MM-dd HH:mm:ss': 'YYYY-MM-DD',
  'yyyy-MM-dd HH:mm': 'YYYY-MM-DD',
  'yyyy-MM-dd': 'YYYY-MM-DD',
  'yyyy-mm-dd': 'YYYY-MM-DD',
  'yyyy-mm': 'YYYY-MM',
  'yyyy-MM': 'YYYY-MM',
  'MM-dd': 'MM-DD',
  'dd': 'DD',
  YYYY: 'YYYY',
  yyyy: 'YYYY'
};

// 适用于只读模式的时间格式
var ORIGIN_TRANSFORM_FORMAT = exports.ORIGIN_TRANSFORM_FORMAT = _extends({}, TRANSFORM_FORMAT, {
  'yyyy-MM-dd HH:mm:ss': 'YYYY-MM-DD hh:mm:ss',
  'yyyy-MM-dd HH:mm': 'YYYY-MM-DD hh:mm'
});